<div class="loading-container">
  <mat-card>
    <mat-card-header>
      <img
        mat-card-image
        class="logo"
        src="images/ft-logo-black.svg"
        alt="FirsTech Connect"
      />
    </mat-card-header>
    <mat-card-content>
      <h2>Loading...</h2>
      <mat-spinner aria-label="Loading" title="Loading"></mat-spinner>
    </mat-card-content>
  </mat-card>
</div>
